/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The NumberBoundary model module.
 * @module model/NumberBoundary
 * @version v0
 */
export default class NumberBoundary {
  /**
   * Constructs a new <code>NumberBoundary</code>.
   * @alias module:model/NumberBoundary
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>NumberBoundary</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/NumberBoundary} obj Optional instance to populate.
   * @return {module:model/NumberBoundary} The populated <code>NumberBoundary</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new NumberBoundary();
      if (data.hasOwnProperty('number1'))
        obj.number1 = ApiClient.convertToType(data['number1'], 'Number');
      if (data.hasOwnProperty('number2'))
        obj.number2 = ApiClient.convertToType(data['number2'], 'Number');
      if (data.hasOwnProperty('useNumber1'))
        obj.useNumber1 = ApiClient.convertToType(data['useNumber1'], 'Boolean');
      if (data.hasOwnProperty('useNumber2'))
        obj.useNumber2 = ApiClient.convertToType(data['useNumber2'], 'Boolean');
      if (data.hasOwnProperty('reversed'))
        obj.reversed = ApiClient.convertToType(data['reversed'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Number} number1
 */
NumberBoundary.prototype.number1 = undefined;

/**
 * @member {Number} number2
 */
NumberBoundary.prototype.number2 = undefined;

/**
 * @member {Boolean} useNumber1
 */
NumberBoundary.prototype.useNumber1 = undefined;

/**
 * @member {Boolean} useNumber2
 */
NumberBoundary.prototype.useNumber2 = undefined;

/**
 * @member {Boolean} reversed
 */
NumberBoundary.prototype.reversed = undefined;

